import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AppContextService {
    initializationFailed = false;
     private apiUrl = environment.apiUrl + '/api';
    private contextSubject = new BehaviorSubject<any>(null);
    context$: Observable<any> = this.contextSubject.asObservable();

    constructor(private http: HttpClient) { }

    loadContext(): Observable<any> {
        const uri = '/firm-context';
        return this.http.get(`${this.apiUrl}${uri}`).pipe(
            tap((context) => this.contextSubject.next(context))
        );
    }

    getContextSnapshot(): any {
        return this.contextSubject.value;
    }
}
